if (!window.Maximize.loadedScript.includes("custom-configurator.js")) {
  window.Maximize.loadedScript.push("custom-configurator.js");

  const toNumber = (value, fallback = 0) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const parseConfig = (container) => ({
    baseVariantId: toNumber(container.dataset.baseVariantId),
    priceVariantId: toNumber(container.dataset.priceVariantId),
    windVariantId: toNumber(container.dataset.windVariantId),
    rainVariantId: toNumber(container.dataset.rainVariantId),
    remoteVariantId: toNumber(container.dataset.remoteVariantId),
    pricePerM2: toNumber(container.dataset.pricePerM2, 1550),
    baseFee: toNumber(container.dataset.baseFee, 1800),
    windPrice: toNumber(container.dataset.windPrice, 180),
    rainPrice: toNumber(container.dataset.rainPrice, 180),
    remotePrice: toNumber(container.dataset.remotePrice, 199),
    antiSlipYesPrice: toNumber(container.dataset.antiSlipYesPrice, 200),
    antiSlipNoPrice: toNumber(container.dataset.antiSlipNoPrice, 0),
    baseProductPrice: toNumber(container.dataset.baseProductPrice, 0),
    priceAdjustmentPercent: toNumber(container.dataset.priceAdjustmentPercent,0),
    calculatorMode: container.dataset.calculatorMode || "rect",
    addUrl: container.dataset.addUrl || "/cart/add.js",
    cartUrl: container.dataset.cartUrl || "/cart",
  });

  const formatCurrency = (value) => {
    const amount = toNumber(value, 0);
    const currency = window?.Shopify?.currency?.active || "EUR";
    const locale = document?.documentElement?.lang || "nl-NL";
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const validate = (width, length, minW, maxW, minL, maxL) => {
    if (!width || !length) return "Veuillez renseigner des dimensions valides";
    if (width < minW) return `Largeur minimale: ${minW}`;
    if (width > maxW) return `Largeur maximale: ${maxW}`;
    if (length < minL) return `Longueur minimale: ${minL}`;
    if (length > maxL) return `Longueur maximale: ${maxL}`;
    return null;
  };

  const getFieldValidation = (value, min, max, label) => {
    if (!value) return { valid: false, message: `${label} est requis` };
    if (value < min) return { valid: false, message: `${label} doit etre au minimum ${min}` };
    if (value > max) return { valid: false, message: `${label} doit etre au maximum ${max}` };
    return { valid: true, message: "" };
  };

  const calculate = (container, config) => {
    const widthInput = container.querySelector(".input-width");
    const lengthInput = container.querySelector(".input-length");
    const sideCInput = container.querySelector(".input-side-c");
    const isCircular = config.calculatorMode === "circular";
    const isBlinds = config.calculatorMode === "blinds";
    const isModular = config.calculatorMode === "modular";
    const isPerimeter = config.calculatorMode === "perimeter";
    const isTriangular = config.calculatorMode === "triangular";
    const width = toNumber(widthInput?.value);
    const length = isCircular ? width : toNumber(lengthInput?.value);
    const sideC = isTriangular ? toNumber(sideCInput?.value) : 0;
    const minW = toNumber(widthInput?.min, 600);
    const maxW = toNumber(widthInput?.max, 2000);
    const minL = isCircular ? minW : toNumber(lengthInput?.min, 600);
    const maxL = isCircular ? maxW : toNumber(lengthInput?.max, 2800);

    const glassInput = container.querySelector('input[name^="calculator-glass"]:checked');
    const glassExtraPerM2 = toNumber(glassInput?.dataset.extraPerM2, 0);

    const randInput = container.querySelector(".rand-option:checked");
    const randExtra = toNumber(randInput?.dataset.randExtra, 0);
    const antiSlipInput = container.querySelector(".anti-slip-option:checked");
    const antiSlipExtra = toNumber(antiSlipInput?.dataset.antiSlipExtra, 0);

    const hasWind = !!container.querySelector(".addon-wind")?.checked;
    const hasRain = !!container.querySelector(".addon-rain")?.checked;
    const hasRemote = !!container.querySelector(".addon-remote")?.checked;
    const blindsPowerInput = container.querySelector(".blinds-power-option:checked");
    const blindsTypeInput = container.querySelector(".blinds-type-option:checked");
    const blindsColorInput = container.querySelector(".blinds-color-option:checked");
    const blindsSmartInput = container.querySelector(".blinds-smart-option:checked");
    const modularPiecesInput = container.querySelector(".modular-pieces-option:checked");
    const modularPieces = toNumber(modularPiecesInput?.value, 2);
    const modularLengthMax = toNumber(modularPiecesInput?.dataset.lengthMax, maxL);

    if (isModular && lengthInput) {
      lengthInput.max = String(modularLengthMax);
      const lengthLabel = container.querySelector(".modular-length-label");
      if (lengthLabel) {
        lengthLabel.textContent = `Longueur totale ${modularPieces} pièces (${minL}mm - ${modularLengthMax}mm)`;
      }
    }

    if (isCircular && lengthInput) {
      lengthInput.value = String(width || "");
    }

    let error = validate(width, length, minW, maxW, minL, isModular ? modularLengthMax : maxL);
    if (!error && isTriangular) {
      if (!sideC || sideC < minL || sideC > maxL) error = `Côté C doit etre entre ${minL} et ${maxL}`;
      if (!error && (width + length <= sideC || width + sideC <= length || length + sideC <= width)) {
        error = "Les côtés ne forment pas un triangle valide";
      }
    }
    if (error) return { error };

    const semiPerimeter = (width + length + sideC) / 2;
    const triAreaMm2 = isTriangular
      ? Math.sqrt(Math.max(0, semiPerimeter * (semiPerimeter - width) * (semiPerimeter - length) * (semiPerimeter - sideC)))
      : 0;
    const surfaceM2 = isCircular
      ? (width * width) / 1000000
      : isTriangular
      ? triAreaMm2 / 1000000
      : (width * length) / 1000000;
    let price = 0;
    if (isBlinds) {
      const baseBlindsPrice = ((surfaceM2 * 150 + 500) * 1.2);
      const powerExtra = toNumber(blindsPowerInput?.dataset.powerExtra, 0);
      const typePricePerM2 = toNumber(blindsTypeInput?.dataset.typePricePerM2, 0);
      const typePrice = surfaceM2 * typePricePerM2;
      const colorPercent = toNumber(blindsColorInput?.dataset.colorPercent, 0);
      const colorPrice = (colorPercent / 100) * baseBlindsPrice;
      const smartExtra = toNumber(blindsSmartInput?.dataset.smartExtra, 0);
      price = baseBlindsPrice + powerExtra + typePrice + colorPrice + smartExtra - 100;
    } else if (isCircular) {
      price = ((surfaceM2 * config.pricePerM2 + config.baseFee) * 1.3) * 1.2-100;
    } else if (isTriangular) {
      price = (((surfaceM2 * 2 * 944) + 354) * 1.3) * 1.2 - 100;
    } else if (isPerimeter) {
      price = ((length * 2) + (width * 2)) * 130 / 1000-100;
    } else {
      price = surfaceM2 * config.pricePerM2 + config.baseFee;
    }
    if (!isBlinds) {
      if (isTriangular) {
        price += ((width * length) * glassExtraPerM2) / 1000000;
      } else if (isModular) {
        price += (width / 1000) * (length / 1000) * (glassExtraPerM2 * 10);
      } else {
        price += surfaceM2 * glassExtraPerM2;
      }
      price += randExtra;
      price += antiSlipExtra;
      if (hasWind) price += config.windPrice;
      if (hasRain) price += config.rainPrice;
      if (hasRemote) price += config.remotePrice;
    }

    if (isPerimeter && config.priceAdjustmentPercent !== 0) {
      price *= 1 + config.priceAdjustmentPercent / 100;
    }
    const total = Math.round(price);

    return {
      total,
      width,
      length,
      sideC,
      isCircular,
      isTriangular,
      glass: (isBlinds || isPerimeter) ? null : (glassInput?.value || "Verre solaire"),
      terminaison: randInput?.value || null,
      antiSlip: antiSlipInput?.value || null,
      hasWind,
      hasRain,
      hasRemote,
      powerOption: blindsPowerInput?.value || null,
      fabricType: blindsTypeInput?.value || null,
      fabricColor: blindsColorInput?.value || null,
      smartControl: blindsSmartInput?.value || null,
      modularPieces: isModular ? modularPieces : null,
    };
  };

  const showMessage = (container, message, isError = false) => {
    const priceEl = container.querySelector(".calculator-total");
    const errorEl = container.querySelector(".calculator-error");
    if (priceEl && !isError) {
      priceEl.textContent = formatCurrency(message);
    }
    if (priceEl && isError) {
      priceEl.textContent = "-";
    }
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.classList.toggle("hidden", !isError);
    }
  };

  const updatePrimaryProductPrice = (container, total, isError = false) => {
    const sectionId = container.dataset.sectionId;
    const formattedPrice = isError ? "À configurer" : formatCurrency(total);

    const formWrapper = container.closest(".product-info__form-wrapper");
    if (formWrapper) {
      const scope = formWrapper.closest(".product-template__content__container") || document;
      const mainPrice = scope.querySelector(".price__container .main-price");
      if (mainPrice) {
        mainPrice.textContent = formattedPrice;
      } else {
        const regularPrice = scope.querySelector(".price__container .price-wrapper .price:not(.compare-at-price)");
        if (regularPrice) regularPrice.textContent = formattedPrice;
      }
    }

    if (sectionId) {
      const stickyPriceEl = document.getElementById(`StickyAddToCart__Price__${sectionId}`);
      if (stickyPriceEl) {
        stickyPriceEl.querySelectorAll(".price:not(.compare-at-price)").forEach((el) => {
          el.textContent = formattedPrice;
        });
      }
    }
  };

  const setFieldState = (container, inputSelector, errorSelector, state) => {
    const input = container.querySelector(inputSelector);
    if (!input) return;
    const wrap = input.closest(".custom-configurator__input-wrap");
    const error = container.querySelector(errorSelector);
    if (wrap) {
      wrap.classList.remove("is-valid", "is-invalid");
      wrap.classList.add(state.valid ? "is-valid" : "is-invalid");
    }
    if (error) {
      error.textContent = state.valid ? "" : state.message;
      error.classList.toggle("hidden", state.valid);
    }
  };

  const validateFieldsUI = (container) => {
    const widthInput = container.querySelector(".input-width");
    const lengthInput = container.querySelector(".input-length");
    const sideCInput = container.querySelector(".input-side-c");
    const isCircular = container.dataset.calculatorMode === "circular";
    const isModular = container.dataset.calculatorMode === "modular";
    const isTriangular = container.dataset.calculatorMode === "triangular";
    const width = toNumber(widthInput?.value);
    const length = isCircular ? width : toNumber(lengthInput?.value);
    const sideC = isTriangular ? toNumber(sideCInput?.value) : 0;
    const widthState = getFieldValidation(
      width,
      toNumber(widthInput?.min, 600),
      toNumber(widthInput?.max, 2000),
      isCircular ? "Diamètre" : isTriangular ? "Côté A" : "Largeur"
    );
    const lengthState = isCircular
      ? { valid: true, message: "" }
      : getFieldValidation(
          length,
          toNumber(lengthInput?.min, 600),
          isModular
            ? toNumber(container.querySelector(".modular-pieces-option:checked")?.dataset.lengthMax, toNumber(lengthInput?.max, 2800))
            : toNumber(lengthInput?.max, 2800),
          isTriangular ? "Côté B" : "Longueur"
        );
    const sideCState = isTriangular
      ? getFieldValidation(sideC, toNumber(sideCInput?.min, 600), toNumber(sideCInput?.max, 2800), "Côté C")
      : { valid: true, message: "" };

    if (isCircular && lengthInput) {
      lengthInput.value = String(width || "");
    }

    setFieldState(container, ".input-width", ".width-error", widthState);
    setFieldState(container, ".input-length", ".length-error", lengthState);
    setFieldState(container, ".input-side-c", ".side-c-error", sideCState);

    return widthState.valid && lengthState.valid && sideCState.valid;
  };

  const buildItems = (config, result) => {
    const properties = {
      _priceUnit: String(result.total),
      ...(result.isCircular
        ? { "Diamètre": result.width }
        : result.isTriangular
        ? { "Côté A": result.width, "Côté B": result.length, "Côté C": result.sideC }
        : { Largeur: result.width, Longueur: result.length }),
    };
    if (result.glass) properties["Couleur du verre"] = result.glass;
    if (result.terminaison) properties["Terminaison"] = result.terminaison;
    if (result.antiSlip) properties["Anti-slip"] = result.antiSlip;
    if (result.hasRain) properties["Capteur de pluie"] = `+${config.rainPrice} EUR`;
    if (result.hasRemote) properties["Télécommande"] = `+${config.remotePrice} EUR`;
    if (result.hasWind) properties["Capteur de vent"] = `+${config.windPrice} EUR`;
    if (result.powerOption) properties["Alimentation"] = result.powerOption;
    if (result.fabricType) properties["Type de tissu"] = result.fabricType;
    if (result.fabricColor) properties["Couleur du tissu"] = result.fabricColor;
    if (result.smartControl) properties["Contrôle smartphone"] = result.smartControl;
    if (result.modularPieces) properties["Nombre de pièces"] = String(result.modularPieces);

    // Single line item: quantity = calculated price in EUR (product must be priced at €1 in Shopify Admin).
    // This ensures checkout shows 1 clean line and discounts apply to the full amount.
    return [{ id: config.baseVariantId, quantity: result.total, properties }];
  };

  const initConfigurator = (container) => {
    const config = parseConfig(container);
    const atcButton = container.closest(".product-info__form-container")?.querySelector("[data-custom-configurator-atc]");
    if (!atcButton) return;

    const refreshPrice = () => {
      validateFieldsUI(container);
      const result = calculate(container, config);
      if (result.error) {
        showMessage(container, result.error, true);
        updatePrimaryProductPrice(container, 0, true);
      } else {
        showMessage(container, String(result.total));
        updatePrimaryProductPrice(container, result.total);
      }
    };

    container.addEventListener("input", refreshPrice);
    container.addEventListener("change", refreshPrice);
    refreshPrice();

    const doAddToCart = async (triggerBtn) => {
      const fieldsOk = validateFieldsUI(container);
      if (!fieldsOk) {
        showMessage(container, "Veuillez remplir correctement tous les champs", true);
        container.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      const result = calculate(container, config);
      if (result.error) {
        showMessage(container, result.error, true);
        container.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      if (config.baseVariantId < 1) {
        showMessage(container, "ID du produit manquant", true);
        return;
      }

      triggerBtn.classList.add("is-loading");
      triggerBtn.setAttribute("disabled", "disabled");

      try {
        const xCartHelper = window.Alpine?.store?.("xCartHelper");
        const cartDrawerEl = document.querySelector("#CartDrawer");
        const cartSectionId = cartDrawerEl?.dataset?.sectionId;
        const sectionsToRender = xCartHelper && cartSectionId
          ? xCartHelper.getSectionsToRender(cartSectionId)
          : [];
        const sections = [...new Set(sectionsToRender.map((s) => s.id))];

        const response = await fetch(config.addUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: buildItems(config, result), sections }),
        });

        if (!response.ok) {
          const data = await response.json();
          throw new Error(data?.description || "Erreur lors de l'ajout au panier");
        }

        const responseData = await response.json();

        if (sectionsToRender.length > 0 && responseData.sections) {
          sectionsToRender.forEach((section) => {
            const el = document.querySelector(section.selector);
            if (!el || !responseData.sections[section.id]) return;
            if (typeof getSectionInnerHTML === "function") {
              el.innerHTML = getSectionInnerHTML(responseData.sections[section.id], section.selector);
            } else {
              const doc = new DOMParser().parseFromString(responseData.sections[section.id], "text/html");
              const content = doc.querySelector(section.selector);
              if (content) el.innerHTML = content.innerHTML;
            }
          });

          const xMiniCart = window.Alpine?.store?.("xMiniCart");
          if (xMiniCart) {
            xMiniCart.handleOpen();
          }
        } else {
          window.location.href = config.cartUrl;
        }
      } catch (error) {
        showMessage(container, error.message || "Erreur lors de l'ajout au panier", true);
      } finally {
        triggerBtn.classList.remove("is-loading");
        triggerBtn.removeAttribute("disabled");
      }
    };

    atcButton.addEventListener("click", () => doAddToCart(atcButton));

    const sectionId = container.dataset.sectionId;
    const stickyBtn = document.getElementById(`StickyAddToCart--Button-${sectionId}`);
    if (stickyBtn) {
      stickyBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        doAddToCart(stickyBtn);
      }, true);
    }
  };

  const initAll = () => {
    document.querySelectorAll(".custom-configurator").forEach((container) => {
      if (container.dataset.initialized === "true") return;
      container.dataset.initialized = "true";
      initConfigurator(container);
    });
  };

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);

  const rerenderCartSections = async () => {
    const cartPageEl = document.querySelector("#MainCart__Items[data-section-id]");
    const cartDrawerEl = document.querySelector("#CartDrawer[data-section-id]");
    const sectionId = cartPageEl
      ? cartPageEl.dataset.sectionId
      : cartDrawerEl
      ? cartDrawerEl.dataset.sectionId
      : null;

    if (!sectionId || !window.Alpine?.store) return;

    const xCartHelper = window.Alpine.store("xCartHelper");
    if (!xCartHelper) return;

    const sectionsToRender = xCartHelper.getSectionsToRender(sectionId);
    const sectionsParam = [...new Set(sectionsToRender.map((s) => s.id))].join(",");

    const res = await fetch(`${window.location.pathname}?sections=${sectionsParam}`);
    const sectionsData = await res.json();

    sectionsToRender.forEach((section) => {
      const el = document.querySelector(section.selector);
      if (!el || !sectionsData[section.id]) return;
      if (typeof getSectionInnerHTML === "function") {
        el.innerHTML = getSectionInnerHTML(sectionsData[section.id], section.selector);
      } else {
        const doc = new DOMParser().parseFromString(sectionsData[section.id], "text/html");
        const content = doc.querySelector(section.selector);
        if (content) el.innerHTML = content.innerHTML;
        else el.innerHTML = sectionsData[section.id];
      }
    });
  };

  const cleanOrphanedBundleItems = async () => {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      const updates = {};
      // Remove legacy "Custom Price" items (Type: Prix) left from the old bundle approach
      cart.items.forEach((item) => {
        if (item.properties?.Type === "Prix") {
          updates[item.key] = 0;
        }
      });
      if (Object.keys(updates).length > 0) {
        _isCleaningUp = true;
        try {
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates }),
          });
        } finally {
          _isCleaningUp = false;
        }
        await rerenderCartSections();
      }
    } catch (e) {
      _isCleaningUp = false;
      console.error("Bundle cleanup error:", e);
    }
  };

  // priceUnit = calculated price for 1 item (stored as _priceUnit property).
  // Shopify quantity = display_qty × priceUnit.
  window.bundleUpdateQty = async (baseKey, currentQty, delta, priceUnit) => {
    const unit = Math.max(1, Math.round(priceUnit));
    const newDisplayQty = Math.max(1, Math.round(currentQty / unit) + delta);
    const newQty = newDisplayQty * unit;
    if (newQty === currentQty) return;
    _isCleaningUp = true;
    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: { [baseKey]: newQty } }),
      });
    } finally {
      _isCleaningUp = false;
    }
    await rerenderCartSections();
  };

  document.addEventListener("cart:updated", cleanOrphanedBundleItems);
  document.addEventListener("maximize:cart-updated", cleanOrphanedBundleItems);

  // Run cleanup on page load to catch orphans from previous sessions
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(cleanOrphanedBundleItems, 600);
  });

  let _isCleaningUp = false;
  let _cleanupTimer = null;
  const _originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const result = await _originalFetch(...args);
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
    if (!_isCleaningUp && (url.includes("/cart/change") || url.includes("/cart/update"))) {
      clearTimeout(_cleanupTimer);
      _cleanupTimer = setTimeout(cleanOrphanedBundleItems, 800);
    }
    return result;
  };
}
